export default function Footer() {
  return (
    <footer className="w-full border-t border-gray-200 dark:border-stone-800 py-6 md:py-8 bg-white dark:bg-[#121212]">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col gap-4 px-4 md:flex-row md:items-center md:px-6">
          <p className="text-sm text-gray-500">
            © 2026 WealthScale. All rights reserved.
          </p>
          <nav className="md:ml-auto flex gap-4 sm:gap-6">
            <a
              className="text-sm hover:underline underline-offset-4 cursor-pointer"
              href="mailto:contact@wealthscale.xyz"
            >
              Contact
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
